import * as yup from "yup";
import { personConnectionSchema } from "@/services/api";

export const deleteConnectionSchema = yup.object().shape({
  connections: yup.array().of(
    yup.object().shape({
      connection: personConnectionSchema,
      selected: yup.boolean().required(),
    }),
  ),
});

export type DeleteConnectionFormValues = yup.InferType<typeof deleteConnectionSchema>;
